import { render, staticRenderFns } from "./AIPackageWindow.vue?vue&type=template&id=0aa77261&"
import script from "./AIPackageWindow.vue?vue&type=script&lang=js&"
export * from "./AIPackageWindow.vue?vue&type=script&lang=js&"
import style0 from "./AIPackageWindow.vue?vue&type=style&index=0&id=0aa77261&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports